// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { FormLayoutUtilsService } from '../../services/form-layout-utils.service';

import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: false,
	selector: 'video-input-entity-dialog',
	templateUrl: './video-input-entity-dialog.component.html',
	styleUrls: ['./video-input-entity-dialog.component.scss']
})
export class VideoInputEntityDialogComponent implements OnInit {
	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	arraySize = 1;
	constructor(private translate: TranslateService, private layoutUtilsService: FormLayoutUtilsService,
		public dialogRef: MatDialogRef<VideoInputEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {

	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
	}

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		this.dialogRef.close(this.data.data);
	}
	public onChange(data) {
		this.data.data = data;
	}
	getNumberRange(end: number): number[] {
		return Array.from({ length: end }, (_, index) => index + 1);
	}
}
